const BASE_ROUTE = "/intake";

export const INTAKE_FORM_ROUTE = {
  BASE: BASE_ROUTE,
  CHOOSE_JOURNEY: `${BASE_ROUTE}/choose-journey`,
  SCHEDULE_VIDEO_CONSULTATION: `${BASE_ROUTE}/schedule-video-consultation/:productId?`,
  ASSESSMENT_FORM: `${BASE_ROUTE}/form/:userPreference/:productId?`,
  SUCCESS: `${BASE_ROUTE}/success`,
} as const;
